import { differenceInHours } from "date-fns";
export const getAthleteMobileState = (athlete) => {
    if (athlete.orgMembership?.isActive) {
        return "active";
    }
    else {
        if (!athlete.activationLinkSent) {
            return "inactive";
        }
        else {
            if (differenceInHours(new Date(), new Date(athlete.activationLinkSent)) > 72) {
                return "expired";
            }
            else {
                return "waiting";
            }
        }
    }
};
export const NEW_ATHLETE_ROLES = ["athlete"];
//# sourceMappingURL=utils.js.map